import { Injectable } from '@angular/core';
import { ContentElementEnum, ContentEnum, RendererType } from '../../models/sections-model';

@Injectable({
  providedIn: 'root'
})
export class NormalizeEnumsService {

  constructor() { }

  normalise(enumType: string | RendererType | ContentEnum | ContentElementEnum): string {
    if (typeof enumType === 'string') {
      return this.normalizeStringValue(enumType);
    }
    // Handle enum values
    switch (enumType) {
      case RendererType.GRID:
        return 'grid';
      case RendererType.BANNER:
        return 'banner';
      case RendererType.RICH_TEXT:
        return 'rich-text';
      case RendererType.BLOGLIST:
        return 'bloglist';
      case RendererType.HEROIMAGE:
        return 'hero-image';
      case RendererType.NEWSLETTER:
        return 'news-letter-sign-up';
      case RendererType.ROW:
        return 'row';
      case RendererType.SLIDER:
        return 'slider';
      case RendererType.CART:
        return 'cart';
      case RendererType.CATEGORY:
        return 'category';
      case RendererType.PRODUCT:
        return 'product';
      case RendererType.STOREFEATURES:
        return 'store-features';
      case RendererType.TESTIMONIALS:
        return 'testimonials'
      case RendererType.BLOG:
        return 'blog';
      case ContentEnum.PRODUCT:
        return "Product Content";
      case ContentEnum.CATEGORY: 
        return "Category Content";
      case ContentEnum.PROMO_TEXT: 
        return "Promotional Text:";
      case ContentEnum.CALL_TO_ACTION: 
        return "Call To Action:";
      case ContentEnum.BLOG_ARTICLE_LINK: 
        return "Blog Article Link:";
      case ContentEnum.CATEGORY_LINK: 
        return "Category Link:";
      case ContentEnum.PRODUCT_LINK: 
        return "Product Link:";
      case ContentEnum.BANNER: 
        return "Banner:";
      case ContentEnum.HEADLINE: 
        return "Headline:";
      case ContentEnum.SUB_HEADLINE: 
        return "Sub Headline:";
      case ContentEnum.GALLERY: 
        return "Gallery:";
      case ContentEnum.PRODUCT_CLASSIFICATION: 
        return "Product Classification:";
      case ContentEnum.PRODUCT_ID: 
        return "Product Identification:";
      case ContentEnum.PRODUCT_STD_FEATS: 
        return "Product Standard Features:";
      case ContentEnum.PRODUCT_SELC_FEATS: 
        return "Product Selectable Features:";
      case ContentEnum.PRODUCT_PRICING: 
        return "Product Price:";
      case ContentEnum.PRODUCT_RATING: 
        return "Product Rating:";
      case ContentEnum.PRODUCT_DIMENSIONS: 
        return "Product Rating:";
      case ContentEnum.PRODUCT_PACKAGING: 
        return "Product Packaging:";
      case ContentEnum.PRODUCT_SHORT_DESC: 
        return "Product Short Description:";
      case ContentEnum.PRODUCT_LONG_DESC: 
        return "Product Long Description:";
      case ContentEnum.PRODUCT_REVIEWS: 
        return "Product Reviews:";
      case ContentEnum.PRODUCT_ADD_TO_CART: 
        return "Add To Cart:";
      case ContentEnum.PRODUCT_SHARE: 
        return "Product Share:";
      case ContentEnum.PRODUCT_DELIVERY: 
        return "Delivery:";
      case ContentEnum.PRODUCT_INVENTORY: 
        return "Inventory:";
      case ContentEnum.PRODUCT_VARIANT: 
        return "Product Variant:";
      case ContentEnum.GENERAL_TEXT: 
        return "General Text:";
      case ContentEnum.SHOPPINGCART: 
        return "Shopping Cart:";
      case ContentEnum.BLOG_HEADER: 
        return "Blog Header:";
      case ContentEnum.BLOG_SUMMARY: 
        return "Blog Summary:";
      case ContentEnum.BLOG_MAIN: 
        return "Blog Main:";
      case ContentEnum.BLOG_SHARE: 
        return "Blog Share:";
      case ContentEnum.BLOG_COMMENTS: 
        return "Blog Comments:";
      case ContentEnum.BLOG_IMAGE: 
        return "Blog Image:";
      case ContentEnum.NAV_LIST: 
        return "Navigation List:";
      case ContentEnum.PRODUCT_CELL: 
        return "Product Cell:";
      case ContentEnum.HERO_IMAGE: 
        return "Hero Image:";
      case ContentEnum.FEATURE: 
        return "Feature:";
      case ContentEnum.TESTIMONIAL: 
        return "Testimonial";
      case ContentElementEnum.TEXT:
        return 'Text';
      case ContentElementEnum.ACTION:
        return 'Action';
      case ContentElementEnum.BUTTON:
        return 'Button';
      case ContentElementEnum.BYLINE:
        return 'ByLine';
      case ContentElementEnum.CAPTION:
        return 'Caption';
      case ContentElementEnum.DATE:
        return 'Date';
      case ContentElementEnum.HEADER:
        return 'Header';
      case ContentElementEnum.HEADING:
        return 'Heading';
      case ContentElementEnum.HTML:
        return 'HTML';
      case ContentElementEnum.IMAGE:
        return 'Image';
      case ContentElementEnum.INPUTFIELD:
        return 'Input Field';
      case ContentElementEnum.LINK:
        return 'Link';
      case ContentElementEnum.LIST_ITEM:
        return 'List Item';
      case ContentElementEnum.NUMBER:
        return 'Number';
      case ContentElementEnum.SELECT:
        return 'Select';
      case ContentElementEnum.SUB_HEADER:
        return 'Sub Header';
      case ContentElementEnum.SUMMARY:
        return 'Summary';
      case ContentElementEnum.SVG:
        return 'SVG';
      case ContentElementEnum.TABLE:
        return 'Table';
      case ContentElementEnum.TRANSFORM:
        return 'Transform';
      default:
        return 'unknown';
    }
  }

      private normalizeStringValue(value: string): string {
      // Handle "RendererType.BANNER" format
      if (value.startsWith('RendererType.')) {
        const enumValue = value.replace('RendererType.', '');
        return this.convertEnumStringToNormalized(enumValue);
      }else if(value.startsWith('ContentEnum.')){
        const enumValue = value.replace('ContentEnum.', '');
        return this.convertEnumStringToNormalized(enumValue);
      }else if(value.startsWith('ContentElementEnum.')){
        const enumValue = value.replace('ContentElementEnum.', '');
        return this.convertEnumStringToNormalized(enumValue);
      }
      
      // Handle direct string values like "banner", "BANNER", "rich-text", "rich_text"
      return value.toLowerCase().replace(/_/g, '-');
    }
    
    private convertEnumStringToNormalized(enumValue: string): string {
      switch (enumValue.toUpperCase()) {
        case "GRID":
          return 'grid';
        case "BANNER":
          return 'banner';
        case "RICH_TEXT":
          return 'rich-text';
        case "BLOGLIST":
          return 'bloglist';
        case "HEROIMAGE":
          return 'hero-image';
        case "NEWSLETTER":
          return 'news-letter-sign-up';
        case "ROW":
          return 'row';
        case "SLIDER":
          return 'slider';
        case "CART":
          return 'cart';
        case "CATEGORY":
          return 'category';
        case "PRODUCT":
          return 'product';
        case "STOREFEATURES":
          return 'store-features';
        case "TESTIMONIALS":
          return 'testimonials'
        case "BLOG":
          return 'blog';
        case "PRODUCT":
          return "Product Content";
        case "CATEGORY": 
          return "Category Content";
        case "PROMO_TEXT": 
          return "Promotional Text";
        case "CALL_TO_ACTION": 
          return "Call To Action";
        case "BLOG_ARTICLE_LINK": 
          return "Blog Article Link";
        case "CATEGORY_LINK": 
          return "Category Link";
        case "PRODUCT_LINK": 
          return "Product Link";
        case "BANNER": 
          return "Banner";
        case "HEADLINE": 
          return "Headline";
        case "SUB_HEADLINE": 
          return "Sub Headline";
        case "GALLERY": 
          return "Gallery";
        case "PRODUCT_CLASSIFICATION": 
          return "Product Classification";
        case "PRODUCT_ID": 
          return "Product Identification";
        case "PRODUCT_STD_FEATS": 
          return "Product Standard Features:";
        case "PRODUCT_SELC_FEATS": 
          return "Product Selectable Features";
        case "PRODUCT_PRICING": 
          return "Product Price";
        case "PRODUCT_RATING": 
          return "Product Rating";
        case "PRODUCT_DIMENSIONS": 
          return "Product Rating";
        case "PRODUCT_PACKAGING": 
          return "Product Packaging";
        case "PRODUCT_SHORT_DESC": 
          return "Product Short Description";
        case "PRODUCT_LONG_DESC": 
          return "Product Long Description";
        case "PRODUCT_REVIEWS": 
          return "Product Reviews";
        case "PRODUCT_ADD_TO_CART": 
          return "Add To Cart";
        case "PRODUCT_SHARE": 
          return "Product Share";
        case "PRODUCT_DELIVERY": 
          return "Delivery";
        case "PRODUCT_INVENTORY": 
          return "Inventory";
        case "PRODUCT_VARIANT": 
          return "Product Variant";
        case "GENERAL_TEXT": 
          return "General Text";
        case "SHOPPINGCART": 
          return "Shopping Cart";
        case "BLOG_HEADER": 
          return "Blog Header";
        case "BLOG_SUMMARY": 
          return "Blog Summary:";
        case "BLOG_MAIN": 
          return "Blog Main";
        case "BLOG_SHARE": 
          return "Blog Share:";
        case "BLOG_COMMENTS": 
          return "Blog Comments";
        case "BLOG_IMAGE": 
          return "Blog Image";
        case "NAV_LIST": 
          return "Navigation List";
        case "PRODUCT_CELL": 
          return "Product Cell";
        case "HERO_IMAGE": 
          return "Hero Image";
        case "FEATURE": 
          return "Feature";
        case "TESTIMONIAL": 
          return "Testimonial";
        case "TEXT":
          return 'Text';
        case "ACTION":
          return 'Action';
        case "BUTTON":
          return 'Button';
        case "BYLINE":
          return 'ByLine';
        case "CAPTION":
          return 'Caption';
        case "DATE":
          return 'Date';
        case "HEADER":
          return 'Header';
        case "HEADING":
          return 'Heading';
        case "HTML":
          return 'HTML';
        case "IMAGE":
          return 'Image';
        case "INPUTFIELD":
          return 'Input Field';
        case "LINK":
          return 'Link';
        case "LIST_ITEM":
          return 'List Item';
        case "NUMBER":
          return 'Number';
        case "SELECT":
          return 'Select';
        case "SUB_HEADER":
          return 'Sub Header';
        case "SUMMARY":
          return 'Summary';
        case "SVG":
          return 'SVG';
        case "TABLE":
          return 'Table';
        case "TRANSFORM":
          return 'Transform';
      default:
        return enumValue.toLowerCase().replace(/_/g, '-');
      }
    }
}
